import React, { useState, useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb";
import axios from "axios";

function PrivacyPolicy() {
  const [content, setContent] = useState({ text: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get("/api/information/public/dataPrivacy");
        setContent(response.data);
      } catch (error) {
        console.error("Error fetching data privacy content:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="bg-white min-h-screen flex items-center justify-center pt-[60px]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-600 mx-auto"></div>
          <p className="mt-4 text-gray-700">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen pt-[60px]">
      {/* Sticky Breadcrumb below header */}

      {/* Main Content */}
      <main
        className="max-w-[1280px] mx-auto py-12 px-6 md:px-12 mt-2"
        aria-label="Data Privacy"
      >
        <div className="-ml-3 -mt-10 sm:mt-6 sm:ml-0">
          <Breadcrumb
            items={[
              { label: "Home", href: "/" },
              { label: "Privacy Policy", href: "/privacy-policy" },
            ]}
          />
        </div>
        <h1 className="text-4xl md:text-3xl text-left mb-4 mt-12">
          Privacy Policy
        </h1>
        <div className="text-gray-700 text-lg leading-relaxed whitespace-pre-wrap text-left" dangerouslySetInnerHTML={{ __html: content.text || "Content coming soon..." }} />
      </main>
    </div>
  );
}

export default PrivacyPolicy;
